import React from 'react'
import ReactDOM from 'react-dom/client'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import { msalConfig } from './config/msalConfig'
import { AuthProvider } from './hooks/useAuth'
import { AppProvider } from './context/AppContext'
import './index.css'

import { DEFAULT_EPICS } from './data/defaultEpics'

const msalInstance = new PublicClientApplication(msalConfig)

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <AuthProvider>
                <AppProvider defaultEpics={DEFAULT_EPICS}>
                    <App />
                </AppProvider>
            </AuthProvider>
        </MsalProvider>
    </React.StrictMode>,
)
